export default {
  namespaced: true,
  providers: {
    title: "Proveedores"
  }
}
